module.exports = __webpack_public_path__ + "img/emmahallhair.aa60ab04.jpg";